// extracted by mini-css-extract-plugin
module.exports = {"data-table":"AppointmentList_data-table__ncdKd","export-button":"AppointmentList_export-button__1ttHj"};